import React from 'react'
import { ComplianceBlock } from '../../pages/employees/card/ui/compliance/compliance-block'
import { useEmployeeCompliance } from '../../pages/employees/card/context/employee-compliance-context'
import type { ComplianceType } from '../../pages/employees/card/types/compliance'

interface InputHrEmployeeComplianceProps {
  schema?: {
    options?: {
      complianceType?: ComplianceType
    }
  }
}

export function InputHrEmployeeCompliance({ schema }: InputHrEmployeeComplianceProps) {
  const ctx = useEmployeeCompliance()
  const type = schema?.options?.complianceType

  if (!ctx || !type || !ctx.employeeId) {
    return null
  }

  const summary = ctx.compliance?.[type]
  if (!summary) {
    return null
  }

  const canEdit = ctx.employeeStatus !== 'dismissed'

  return (
    <ComplianceBlock
      employeeId={ctx.employeeId}
      type={type}
      summary={summary}
      canEdit={canEdit}
      onRefresh={ctx.onRefresh}
      embedded
    />
  )
}
